import "./index.css";
import wavehand from "../../assets/wavinghand/waving-hand-light.svg";
import TypeWriter from "../typewriter/TypeWriter";
import LottieComponent from "../lottie/Lottie";
import SocialMedia from "../socialmedia";
import { BorderButton } from "../button";
import FillButton from "../button/FillButton";


const Hero = () => {
  return (
    <div className="hero" id="Home">
      <div className="section-left">
        <div className="section_hi">
          <h2 className="text-4xl">Hello</h2>
          <img src={wavehand} height={45} width={40} alt="Hi icon"></img>
        </div>
        <div className="section_pratik_jha">
          <h1 className="text-3xl">I am Pratik Jha</h1>
        </div>
        <div className="section_developer text-4xl">
          <TypeWriter />
        </div>

        <div>
          <SocialMedia />
        </div>
        
          <div style={{ display: "flex", marginTop: "3rem", gap: "1rem" ,height:"3.5rem"}}>
            <BorderButton name="Resume"/>
            <FillButton name="Let's talk"/>
          </div>
        
      </div>
      
        <div className="section-right">
          <LottieComponent />
        </div>
      
    </div>
  );
};

export default Hero;
